import React from "react";
import SortSegments from "./SortSegments";

// Bolds only the leading number (design section 8's markup: `<span
// class="font-medium text-white">2</span> kits ...`), whether the summary
// starts with a plain count ("2 kits") or "Showing 48 of 132 kits".
function Summary({ text }) {
  const m = text.match(/^(\D*)(\d+)(.*)$/s);
  if (!m) return <>{text}</>;
  const [, prefix, num, rest] = m;
  return (
    <>
      {prefix}
      <span className="font-medium text-white">{num}</span>
      {rest}
    </>
  );
}

// design doc section 8: count + active-filter summary + Clear filters on the
// left (aria-live, so a screen reader hears the new count after a change),
// the sort segments on the right. This line is where "filter" (orange,
// left) and "sort" (white, right) sit side by side without ever mixing.
//
// `summary` is `null` while the count isn't trustworthy yet -- first load
// AND a failed fetch (design section 9.1 specifies the skeleton bar for the
// former; the same reasoning -- never show a fabricated "0 kits" next to an
// error message -- extends it to the latter). `clearVisible` still works
// either way: it only depends on the URL-parsed filters, not on a response.
// sortVisible is false in the favourites view: that endpoint returns one fixed
// order (most recently favourited first) and takes no sort param, so the
// segments would be three buttons that do nothing.
export default function ResultsLine({ summary, clearVisible, onClear, sort, onSortChange, sortVisible = true }) {
  return (
    <div className="mt-8 flex flex-wrap items-center justify-between gap-x-6 gap-y-3 border-t border-white/10 pt-4">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1" aria-live="polite">
        {summary == null ? (
          <div className="h-4 w-24 rounded bg-white/10 animate-pulse" />
        ) : (
          <p className="text-sm text-[#A1A1AA]">
            <Summary text={summary} />
          </p>
        )}
        {clearVisible && (
          <button
            type="button"
            onClick={onClear}
            className="font-mono text-xs uppercase tracking-wider text-[#A1A1AA] hover:text-[#FF5500] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5500] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505]"
          >
            Clear filters
          </button>
        )}
      </div>
      {sortVisible && <SortSegments sort={sort} onChange={onSortChange} />}
    </div>
  );
}
